import SetResumeModal from "../modals/SetResumeModal";

export const GLOBAL_MODALS = {
  "set-resume-modal": SetResumeModal
};